import React from "react";

export function Logo({ className = "", size = 28, showText = true, dark = false }) {
  const text = dark ? "#FFFFFF" : "hsl(217 100% 33%)";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="app-logo">
      <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Truck Sharing">
        <rect width="48" height="48" rx="6" fill="hsl(217 100% 33%)" />
        {/* loop arrow representing optimized empty return */}
        <path d="M12 30a12 12 0 0 1 22-7" stroke="#FF5500" strokeWidth="3.2" strokeLinecap="round" fill="none" />
        <path d="M34 16v7h-7" stroke="#FF5500" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        {/* truck profile */}
        <path d="M10 34h16v-9h6l4 4v5h2" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <circle cx="16" cy="36" r="2.6" fill="#FFFFFF" />
        <circle cx="34" cy="36" r="2.6" fill="#FFFFFF" />
      </svg>
      {showText && (
        <span className="font-display font-extrabold tracking-tighter leading-none" style={{ color: text, fontSize: size * 0.62 }}>
          Truck<span style={{ color: "#FF5500" }}>Sharing</span>
        </span>
      )}
    </div>
  );
}
